import { Chip } from "@mui/material";

export default function LanguageChip({ language }: any) {
  if (!language) return null;
  return (
    <Chip size="small" variant="outlined" label={language} color="primary" />
  );
}
